import { usePlanAccess } from '../../../../components/gating/PlanGate';
import FeatureLocked from '../../../../components/gating/FeatureLocked';
import ChatList from './sections/ChatList/ChatList';
import ChatConsole from './sections/ChatConsole/ChatConsole';

const TravellerChatWorkspace = () => {
  const { hasAccess: isChatUnlocked } = usePlanAccess('starter');

  return (
    <div className="relative">
      <div className="flex flex-col md:flex-row bg-white border border-gray-200 md:rounded-2xl overflow-hidden shadow-sm h-[calc(100vh-210px)] min-h-[580px]">
        <ChatList isChatUnlocked={isChatUnlocked} />
        <ChatConsole />
      </div>

      {!isChatUnlocked && <FeatureLocked featureKey="chat" overlay={true} />}
    </div>
  );
};

export default TravellerChatWorkspace;
